export default "__VITE_ASSET__BZbLqSFc__"